// extracted by mini-css-extract-plugin
export var bubble = "_38-0";
export var container = "_38-f";
export var contrastBorder = "_38-g";
export var greyOut = "_38-2";
export var initialsColor0 = "_38-3";
export var initialsColor1 = "_38-4";
export var initialsColor10 = "_38-d";
export var initialsColor11 = "_38-e";
export var initialsColor2 = "_38-5";
export var initialsColor3 = "_38-6";
export var initialsColor4 = "_38-7";
export var initialsColor5 = "_38-8";
export var initialsColor6 = "_38-9";
export var initialsColor7 = "_38-a";
export var initialsColor8 = "_38-b";
export var initialsColor9 = "_38-c";
export var initialsWrapper = "_38-1";
export var large = "_38-l";
export var medium = "_38-k";
export var mediumSmall = "_38-j";
export var mediumSmallMedium = "_38-o";
export var micro = "_38-h";
export var small = "_38-i";
export var tiny = "_38-n";
export var xTiny = "_38-m";